module.exports = __webpack_public_path__ + "assets/img/bmy-a.359d7cff.png";